import apple from "../assets/img/cards/apple.png";
import banana from "../assets/img/cards/banana.png";
import blackberry from "../assets/img/cards/blackberry.png";
import carrot from "../assets/img/cards/carrot.png";
import cherry from "../assets/img/cards/cherry.png";
import cucumber from "../assets/img/cards/cucumber.png";
import eggplant from "../assets/img/cards/eggplant.png";
import grape from "../assets/img/cards/grape.png";
import kiwi from "../assets/img/cards/kiwi.png";
import lemon from "../assets/img/cards/lemon.png";
import onion from "../assets/img/cards/onion.png";
import orange from "../assets/img/cards/orange.png";
import pear from "../assets/img/cards/pear.png";
import pineapple from "../assets/img/cards/pineapple.png";
import pomegranate from "../assets/img/cards/pomegranate.png";
import potato from "../assets/img/cards/potato.png";
import raspberry from "../assets/img/cards/raspberry.png";
import strawberry from "../assets/img/cards/strawberry.png";
import tomato from "../assets/img/cards/tomato.png";
import watermelon from "../assets/img/cards/watermelon.png";

export const IMAGE_CARDS = [
  {
    id: 1,
    value: apple,
    type: "img",
  },
  {
    id: 2,
    value: banana,
    type: "img",
  },
  {
    id: 3,
    value: blackberry,
    type: "img",
  },
  {
    id: 4,
    value: carrot,
    type: "img",
  },
  {
    id: 5,
    value: cherry,
    type: "img",
  },
  {
    id: 6,
    value: cucumber,
    type: "img",
  },
  {
    id: 7,
    value: eggplant,
    type: "img",
  },
  {
    id: 8,
    value: grape,
    type: "img",
  },
  {
    id: 9,
    value: kiwi,
    type: "img",
  },
  {
    id: 10,
    value: lemon,
    type: "img",
  },
  {
    id: 11,
    value: onion,
    type: "img",
  },
  {
    id: 12,
    value: orange,
    type: "img",
  },
  {
    id: 13,
    value: pear,
    type: "img",
  },
  {
    id: 14,
    value: pineapple,
    type: "img",
  },
  {
    id: 15,
    value: pomegranate,
    type: "img",
  },
  {
    id: 16,
    value: potato,
    type: "img",
  },
  {
    id: 17,
    value: raspberry,
    type: "img",
  },
  {
    id: 18,
    value: strawberry,
    type: "img",
  },
  {
    id: 19,
    value: tomato,
    type: "img",
  },
  {
    id: 20,
    value: watermelon,
    type: "img",
  },
];
